if(typeof require !== 'undefined' && typeof _ === 'undefined'){
  var _ = require('lodash');
}

angular.module('admin.directives')

.directive('agentUserList', ['AgentService', 'UserService', 'FEATURES', function(AgentService, UserService, FEATURES){
  return {
    restrict: 'EA',
    controllerAs: 'agentUserListCtrl',
    bindToController: {
      agent: '=',
      listType: '@',
    },
    scope: {},
    templateUrl: function(el, attrs){
      return attrs.templateUrl || '/admin/templates/partials/agent-user-list.html';
    },

    controller: function(){
      let ctrl = this;

      ctrl.doSearch = function(){
        if(ctrl.listType === 'emailIssues')
          return UserService.getUsersWithEmailIssues(ctrl.agent.id);

        if(ctrl.listType === 'invited')
          return UserService.getLeads(ctrl.agent.id);

        if(ctrl.listType === 'sharedClients') {
          return AgentService.sharedClients(ctrl.agent.id)
            .then(data => _.uniq(data, datum => datum.userId))
            .then(data => _.filter(data, datum => datum.userId));
        }
      }

      ctrl.getUsers = function(showLoading){
        ctrl.error = '';
        ctrl.loading = typeof showLoading !== 'undefined' ? showLoading : true;

        ctrl.doSearch()
          .then((data) => {
            ctrl.users = data;
            ctrl.loading = false;
          })
          .catch((err) => {
            ctrl.loading = false;
            ctrl.error = 'There was an error getting your list of clients.';
          });
      }

      ctrl.editUser = (user) => {
        ctrl.userForEdit = user;
        ctrl.currentModal = 'editUser';
      };

      ctrl.closeModal = () => {
        ctrl.currentModal = null;
        ctrl.userForEdit = null;
      };

      ctrl.closeModalAndRefresh = () => {
        ctrl.closeModal();
        ctrl.getUsers(false);
      };

      ctrl.showV2Digest = _.contains(ctrl.agent.features, FEATURES.DIGEST_V2)

      ctrl.getUsers();
    },

    link: function($scope, el, attrs, ctrl){
      $scope.$watch('agentUserListCtrl.listType', function(oldVal, newVal){
        if(oldVal !== newVal)
          ctrl.getUsers();
      });
    }

  }

}]);
